module.exports = __webpack_public_path__ + "assets/qing.3a2d9a99.svg";